var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7031 10H0.390625V33.75H35.7031V10Z",
    fill: "#FFC970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6484 33.75L18.0469 15.3984L2.44531 33.75H33.6484Z",
    fill: "#FFB233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0469 17.8125L32.1875 33.75H3.90625L18.0469 17.8125Z",
    fill: "#FFC970"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0469 27.9688L0.390625 12.0312V10H35.7031V12.0312L18.0469 27.9688Z",
    fill: "#FFB233"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0469 25.9375L0.390625 10H35.7031L18.0469 25.9375Z",
    fill: "#FFDCA3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1094 11.7188C27.1094 15.6016 30.2578 18.75 34.1406 18.75C34.6797 18.75 35.2031 18.6875 35.7031 18.5781V10H27.3203C27.1797 10.5469 27.1094 11.125 27.1094 11.7188Z",
    fill: "#FFB233"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3203 10C27.1797 10.5469 27.1094 11.125 27.1094 11.7188C27.1094 13.4453 27.7344 15.0313 28.7734 16.2578L35.7031 10H27.3203Z",
    fill: "#FFC970"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1406 17.1875C37.1609 17.1875 39.6094 14.7391 39.6094 11.7188C39.6094 8.69844 37.1609 6.25 34.1406 6.25C31.1203 6.25 28.6719 8.69844 28.6719 11.7188C28.6719 14.7391 31.1203 17.1875 34.1406 17.1875Z",
    fill: "#D84861"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 7C37.3828 7.8125 37.6562 8.75781 37.6562 9.76562C37.6562 12.7891 35.2109 15.2344 32.1875 15.2344C31.1797 15.2344 30.2344 14.9609 29.4219 14.4844C30.375 16.1016 32.125 17.1875 34.1406 17.1875C37.1641 17.1875 39.6094 14.7422 39.6094 11.7188C39.6094 9.71094 38.5234 7.95312 36.9062 7Z",
    fill: "#C12944"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1875 12.5C33.6977 12.5 34.9219 11.2758 34.9219 9.76562C34.9219 8.25547 33.6977 7.03125 32.1875 7.03125C30.6773 7.03125 29.4531 8.25547 29.4531 9.76562C29.4531 11.2758 30.6773 12.5 32.1875 12.5Z",
    fill: "#E17084"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1406 16.016C31.7734 16.016 29.8438 14.0863 29.8438 11.7192C29.8438 10.5551 30.2969 9.46915 31.1328 8.65665C31.9609 7.84415 33.0547 7.40665 34.2188 7.42228C35.3672 7.44572 36.4453 7.91447 37.2422 8.75822C38.0469 9.60197 38.4688 10.7035 38.4297 11.8598C38.3984 12.8676 38.0156 13.8363 37.3516 14.5785C37.0234 14.9457 36.5234 15.0707 36.0625 14.891C35.6016 14.7192 35.3047 14.2895 35.3047 13.7973V13.6723H34.1328C33.0547 13.6723 32.1797 12.7973 32.1797 11.7192C32.1797 10.641 33.0547 9.76603 34.1328 9.76603C35.2109 9.76603 36.0859 10.641 36.0859 11.7192V13.7973C36.0859 14.0473 36.2813 14.141 36.3359 14.1645C36.3984 14.1879 36.6016 14.2426 36.7656 14.0629C37.3047 13.4535 37.6172 12.6645 37.6484 11.8363C37.6797 10.891 37.3281 9.99259 36.6719 9.29728C36.0156 8.60978 35.1328 8.21915 34.1953 8.20353C33.2422 8.1879 32.3437 8.54728 31.6719 9.21134C30.9922 9.8754 30.6172 10.766 30.6172 11.7192C30.6172 13.6567 32.1953 15.2348 34.1328 15.2348V16.016H34.1406ZM34.1406 10.5473C33.4922 10.5473 32.9688 11.0707 32.9688 11.7192C32.9688 12.3676 33.4922 12.891 34.1406 12.891H35.3125V11.7192C35.3125 11.0707 34.7891 10.5473 34.1406 10.5473Z",
    fill: "#FFC970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountEmail);
export default __webpack_public_path__ + "static/media/account-email.65bec86ad1ef1149938006c28186aab5.svg";
export { ForwardRef as ReactComponent };